//=include lib/jquery-1.9.1.min.js
//=include lib/modernizr.js
import "../sass/_main.scss";
$ = jQuery;

$(document).ready(function () {
	if ($("body.home").length) {
		btScroll();
		projectsLinks();

		// $('body').addClass('overflowhide');

		// introMobile();
	} else {
		projectsFiletsLinks();
		projectsCollaborator();
	}

	if ($(".page-projet").length) {
		btShare();
	}

	// MENU
	$(".Navigation .Navigation-toggler").on("click", function () {
		$("body").toggleClass("nav-open");

		if ($(".NavigationMenuMobile").attr("class").indexOf("hide") > -1) {
			$(".NavigationMenuMobile").toggleClass("hide");
			setTimeout(function () {
				$(".NavigationMenuMobile").toggleClass("transition");
			}, 350);
		} else {
			$(".NavigationMenuMobile").toggleClass("transition");
			setTimeout(function () {
				$(".NavigationMenuMobile").toggleClass("hide");
			}, 800);
		}
	});
});

function btShare() {
	var urlToShare = window.location.href;
	// console.log(urlToShare);

	var urlToShareFB = "https://www.facebook.com/sharer/sharer.php?u={url}",
		urlToShareTW = "https://twitter.com/intent/tweet/?url={url}",
		urlToShareG = "https://plus.google.com/share?url={url}&hl=fr";

	urlToShareFB = urlToShareFB.replace("{url}", urlToShare);
	urlToShareTW = urlToShareTW.replace("{url}", urlToShare);
	urlToShareG = urlToShareG.replace("{url}", urlToShare);

	$(".elementor-social-icons-wrapper a.elementor-social-icon-facebook").attr(
		"href",
		urlToShareFB
	);
	$(".elementor-social-icons-wrapper a.elementor-social-icon-twitter").attr(
		"href",
		urlToShareTW
	);
	$(
		".elementor-social-icons-wrapper a.elementor-social-icon-google-plus"
	).attr("href", urlToShareG);

	// $('.elementor-social-icons-wrapper a.elementor-social-icon-facebook').on('click',function(e){
	//   e.preventDefault;
	//   window.open(urlToShareFB,"nom_popup","menubar=no, status=no, scrollbars=no, menubar=no, width=200, height=100");
	// });
	// $('.elementor-social-icons-wrapper a.elementor-social-icon-twitter').on('click',function(e){
	//   e.preventDefault;
	//   window.open(urlToShareTW,"nom_popup","menubar=no, status=no, scrollbars=no, menubar=no, width=200, height=100");
	// });
	// $('.elementor-social-icons-wrapper a.elementor-social-icon-google-plus').on('click',function(e){
	//   e.preventDefault;
	//   window.open(urlToShareG,"nom_popup","menubar=no, status=no, scrollbars=no, menubar=no, width=200, height=100");
	// });
}

// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $("header").outerHeight();

// var wheeling;

// $(window).on('mousewheel', function (e) {
//   if (!wheeling) {
//     console.log('Start wheeling')
//   }

//   clearTimeout(wheeling);
//   wheeling = setTimeout(function() {
//     console.log('Stop  wheeling');
//     wheeling = undefined;

//     if ( $('body').attr('class').indexOf('home')>-1){
//         intro(e.originalEvent.deltaY);
//     }else{
//     }

//   }, 250);
//   // console.log(e.originalEvent.deltaY)

// });

// var inIntro = true;
// function intro(onWheeling){

//     var st = $(this).scrollTop();
//     if(st == 0){

//         // alert(onWheeling)

//         if(onWheeling < 300 && onWheeling > 0 && inIntro){
//             console.log('Presque')
//             introPresque()

//         }
//         if(onWheeling > 300 && inIntro){
//             console.log('Down')
//             introDown()
//         }
//         if(onWheeling < -300 && !inIntro){
//             console.log('Retour')
//             introRetour()
//         }
//         console.log(onWheeling)
//     }
// }
// function introMobile(){
//     // var forSwipeHammer = document.getElementById('htmlcarousel');
//     // var mc = new Hammer(forSwipeHammer);

// }

function introPresque() {
	$(".elementor-html-carousel-end").css("margin", "70vh 0 0 0");

	setTimeout(function () {
		$(".elementor-html-carousel-end").css("margin", "100vh 0 0 0");
	}, 800);
}

function introDown() {
	$("body.html-carousel #content-wrap").css("padding", "0");
	$(".elementor-html-carousel-end").css("margin", "0");
	$(
		".elementor-column-gap-default>.elementor-row>.elementor-column>.elementor-element-populated"
	).css("padding", "0px");
	inIntro = false;

	// setTimeout(function() {
	//     $('body').removeClass('overflowhide')
	// }, 500);

	setTimeout(function () {
		$("body").addClass("onlyprojects");
	}, 500);
}

function introRetour() {
	$("body.html-carousel #content-wrap").css("padding", "120px 0 0 0");
	$(".elementor-html-carousel-end").css("margin", "100vh 0 0 0");
	$(
		".elementor-column-gap-default>.elementor-row>.elementor-column>.elementor-element-populated"
	).css("padding", "10px");

	inIntro = true;

	// $('body').addClass('overflowhide');
}

setInterval(function () {
	if (didScroll) {
		hasScrolled();
		didScroll = false;
	}
}, 250);

function hasScrolled() {
	var st = $(this).scrollTop();

	if (Math.abs(lastScrollTop - st) <= delta) {
		return;
	}

	if (st > lastScrollTop && st > navbarHeight) {
		// Scroll Down
		$("header").removeClass("nav-down").addClass("nav-up");
		$(".mark").removeClass("nav-down").addClass("nav-up");
	} else {
		// Scroll Up
		if (st + $(window).height() < $(document).height()) {
			$("header").removeClass("nav-up").addClass("nav-down");
			$(".mark").removeClass("nav-up").addClass("nav-down");
		}
	}

	lastScrollTop = st;
}

introStates = "top";
function heightScroll() {
	var st = $(this).scrollTop();
	if (Math.abs(lastScrollTop - st) <= delta) {
		return;
	}

	if (st < $(window).height()) {
		// $('html, body').animate({
		//    scrollTop:$('#content-wrap').offset().top
		// }, 750);

		$("body").removeClass("nav-visible");
	} else {
		// bottom
		if (lastScrollTop < $(window).height()) {
			// $('html, body').animate({
			//   scrollTop:$('#projects').offset().top
			// }, 750);
			$("body").addClass("nav-visible");
			// console.log('bottom')

			// $('body.html-carousel #content-wrap').css('padding','0')
			// $('.elementor-html-carousel-end').css('margin','0')
			if (lastScrollTop != 0) {
				// $('body.html-carousel #content-wrap').css('padding','0')
				// $('.elementor-html-carousel-end').css('margin','0')
			} else {
			}
		}
	}

	// console.log(st)

	lastScrollTop = st;
}

function btScroll() {
	$(".html-carousel-wrapper .bt_scroll a").on("click", function (e) {
		e.preventDefault;
		introDown();
	});
}

function projectsLinks() {
	$(".Navigation .NavigationMenu li a.projects").on("click", function (e) {
		e.preventDefault;
		// console.log( $(this).attr('href') );
		return false;
	});
}

function projectsFiletsLinks() {
	console.log('ici')
	$(".Navigation .NavigationMenu li.projects .sublink a").on(
		"click",
		function (e) {
			e.preventDefault;

			menuFilter = $(this).parent().attr("class");
			menuFilter = "?filter=" + menuFilter.split(" ")[1] + "#projects";

			linkHomeFilter =
				$(".Navigation-logo a").attr("href") + "/" + menuFilter;
			document.location.href = linkHomeFilter;
			return false;
		}
	);
}

// Smooth scroll intro

// Collaborators
function projectsCollaborator() {
	$(".collaborators li").each(function (i) {
		linkCollab = $(this)
			.text()
			.toLowerCase()
			.replace(" ", "-")
			.replace(" ", "-")
			.replace(" ", "-");
		// .normalize('NFD')
		// .replace(/[\u0300-\u036f]/g, "")

		// console.log(linkCollab)

		linkAgence =
			$(".Navigation-logo a").attr("href") +
			"/" +
			"agence/?collab=" +
			linkCollab;
		divLinkCollab =
			'<a href="' + linkAgence + '">' + $(this).text() + "</a>";

		$(this).text("");
		$($(this)).append(divLinkCollab);
	});
}

import PhotoSwipeLightbox from "./lib/photoswipe";

const addSource = () => {
	const styles = document.createElement("style");
	styles.setAttribute("rel", "stylesheet");
	styles.setAttribute(
		"href",
		"https://unpkg.com/photoswipe@5.3.7/dist/photoswipe.css"
	);
	document.body.append(styles);

	// const script = document.createElement("script");
	// script.setAttribute('src', "https://unpkg.com/photoswipe@5.3.7/dist/photoswipe.esm.js")
	// document.body.append(script)
};

const zoom = (e) => {
	e.preventDefault();
	const target = e.target;
	console.log(target);
};
const visualHandler = () => {
	const images_temp = [
		...document.querySelectorAll(".single.single-work img"),
	];
	const images = [];
	images_temp.map((image, index) => {
		if (
			!image.parentNode.classList.contains("pop-thumbnail") &&
			!image.parentNode.classList.contains("thumbnail") &&
			!image.src.includes("logo")
		) {
			images.push(image);
		}
	});
	// console.log(images)

	images.map((image) => {
		const parent = image.parentNode;
		var divConteneur = document.createElement("a");
		divConteneur.id = "zoom";
		divConteneur.href = image.src;
		divConteneur.append(image);
		parent.appendChild(divConteneur);

		// parent.addEventListener('click', zoom);
	});
};

if (document.querySelector(".single-work")) {
	addSource();
	visualHandler();

	const lightbox = new PhotoSwipeLightbox({
		gallery: "#page-content",
		children: "#zoom",
	});
	lightbox.init();
	document.querySelector('.pswp').remove();
}
